export function Util_doNothing(..._: any[]): void {
    return null
}
